var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17012 8.71318C2.03394 8.49754 1.96584 8.38972 1.92772 8.22342C1.89909 8.0985 1.89909 7.9015 1.92772 7.77658C1.96584 7.61028 2.03394 7.50246 2.17012 7.28682C3.29553 5.50484 6.6454 1 11.7504 1C16.8554 1 20.2053 5.50484 21.3307 7.28682C21.4669 7.50246 21.535 7.61028 21.5731 7.77658C21.6017 7.9015 21.6017 8.0985 21.5731 8.22342C21.535 8.38972 21.4669 8.49754 21.3307 8.71318C20.2053 10.4952 16.8554 15 11.7504 15C6.6454 15 3.29553 10.4952 2.17012 8.71318Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7504 11C13.4073 11 14.7504 9.65685 14.7504 8C14.7504 6.34315 13.4073 5 11.7504 5C10.0935 5 8.7504 6.34315 8.7504 8C8.7504 9.65685 10.0935 11 11.7504 11Z",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionStatus);
export default __webpack_public_path__ + "static/media/Transaction_status.3fad2f520ee4b92f6b5e0855f4547a1d.svg";
export { ForwardRef as ReactComponent };